// Vendors
import { AccordionComponent, ButtonComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
// Constants
import { ERROR_ACCORDION_COMPONENT_BUTTON_PROPS } from './constants/error-accordion.constants';
// Event Handlers
import { ErrorAccordionHandlers } from './handlers/error-accordion.handlers';
// Styles
import {
  ErrorAccordionComponentStyled,
  ErrorAccordionPreComponentStyled,
} from './error-accordion.component.styled';
// Translations
import { COPY_TEXT, SHOW_DETAILS } from './translations/error-accordion.translations';
// Types
import type { ErrorAccordionComponentType } from './types/error-accordion.type';
// Utilities
import { mapShowErrorAccordingType } from './utils/error-accordion.utils';

const ErrorAccordionComponent = ({
  description,
  error,
}: ErrorAccordionComponentType): React.ReactElement | null => {
  const { formatMessage } = useIntl();
  const { handleCopyStackTraceErrorButtonClick } = ErrorAccordionHandlers({ error });

  return (
    <AccordionComponent title={formatMessage({ id: SHOW_DETAILS })}>
      <ErrorAccordionComponentStyled>
        <ErrorAccordionPreComponentStyled>
          {mapShowErrorAccordingType(description)}
        </ErrorAccordionPreComponentStyled>
        <ButtonComponent
          {...ERROR_ACCORDION_COMPONENT_BUTTON_PROPS}
          onClick={handleCopyStackTraceErrorButtonClick}
        >
          <FormattedMessage id={COPY_TEXT} />
        </ButtonComponent>
      </ErrorAccordionComponentStyled>
    </AccordionComponent>
  );
};

export { ErrorAccordionComponent };
